import * as React from "react";
import { CardType } from "../../../../data";

export class SecondaryHeading extends React.PureComponent<{
    cardType: CardType
}, {}> {
    render() {
        return (
            <h4 className={`rj-ev-list__sub-heading ${`rj-ev-list__sub-heading--${this.props.cardType.toLowerCase()}`}`} data-uat="div-ev-list-sub-heading">
                {this.props.children}
            </h4>
        )
    }
}